export const Settings = {
  // Cleopatra's Fire base game and free spins are a 5x4 grid (GDD §1).
  // Everything downstream derives from these: GAME_LAYOUT below, SPRITE_COUNT
  // in ReelControllerV2 (SYMBOLS_VISIBLE*2+2), the flat overlay's cell grid,
  // and DEFAULT_SLOTFACE in SymbolData.
  REEL_COUNT: 5,
  SYMBOLS_VISIBLE: 4,
  // Hold & Win plays on its own, taller grid: 5x8 (GDD §8.1). The bottom 4
  // rows start active, the top 4 are locked and open upward. Nothing reads
  // this yet — the H&W reel set will, instead of the base grid above.
  HOLD_AND_WIN: {
    REEL_COUNT: 5,
    SYMBOLS_VISIBLE: 8,
  },
  // One cell of game_view's reel window: 925 x 740 units = 5 x 4 cells of 185
  // (1 unit = 1 stage px). The whole game_view scene is drawn at
  // cell / SYMBOL_HEIGHT, and the separators sit on the 185 pitch.
  //
  // Symbol ART size inside the cell is SYMBOL_SCALE_OVERRIDES below, never
  // this — changing this moves the frame with the symbols.
  SYMBOL_WIDTH: 185,
  SYMBOL_HEIGHT: 185,
  // Per-category scale multipliers. Keys match symbolData.symbolPay values.
  // Unlisted categories fall back to DEFAULT.
  //
  // This is the knob that sizes the SYMBOLS inside their cells. Do NOT use
  // SYMBOL_WIDTH/HEIGHT for that: the whole game_view scene is scaled by
  // cell / SYMBOL_HEIGHT too, so changing it moves the reel frame with the
  // symbols (tried 264, 2026-09-28 — the frame shrank around the grid).
  //
  // 1: the reel_symbol rigs and the winbox are authored in the 185-unit cell.
  // Read by ReelControllerV2 (textures), both overlay controllers (spines),
  // the win box and the mini paytable, so all of them stay the same size.
  SYMBOL_SCALE_OVERRIDES: {
    DEFAULT: 1,
  },
  // The jackpot coin's lettering size (cj `coin_major`, 2026-09-29): its letters
  // stand ~50 rig units without the lip. In Noto Sans ExtraBold (coin_value_bw)
  // digits stand 0.714 x the font size (its cap height), plus the outline
  // outside the glyph 0.138 -> 0.852 x font = 50 -> font ≈ 58.7 = 0.274 x
  // SYMBOL_HEIGHT. (0.29 was worked out for Troika, dropped from this game.)
  // COIN_VALUE_FONT_SIZE_MULTIPLIER: 0.25, // Font size for coin values as fraction of symbol height
  COIN_VALUE_FONT_SIZE_MULTIPLIER: 0.274,

  APP: {
    RGS_PROVIDER: "Dmon",
    GAME_NAME: "Midnight Alchemy",
    UI_THEME: "secondary",
  },
};

// Game layout configurationan - pre-generated arrays for reel and symbol indices
export const GAME_LAYOUT = {
  REEL_COUNT: Settings.REEL_COUNT,
  SYMBOLS_VISIBLE: Settings.SYMBOLS_VISIBLE,
  SYMBOL_INDICES: Array.from(
    { length: Settings.SYMBOLS_VISIBLE },
    (_, idx) => idx,
  ),
  REEL_INDICES: Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx),
  MIDDLE_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2), // Middle reel index (for 5 reels = 2)
  SECOND_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2) - 1, // Second reel index (for 5 reels = 1)
};

export const APP_VERSION = "27.04.2026 - 14:25";

// Stage dimensions - centralized configuration
export const STAGE_DIMENSIONS = {
  MAX_WIDTH: 3840, // Maximum stage width for UI constraint and background scaling
  MAX_HEIGHT: 3200, // Maximum background height (for reference)
};
